import { Flex, Text, Box } from "rebass/styled-components";

interface Props {
  title: string;
  items: { title: string; desc: string }[];
  numCols: number;
  variant?: string;
}

export interface NumbersTileProps {
  title: string;
  desc: string;
  width?: string;
  variant?: string;
}

const NumbersTile = (props: NumbersTileProps) => {
  const { title, desc, width, variant } = props;
  return (
    <Flex variant={`numbersGrid.${variant}.tile`} sx={{ width: width }}>
      <Box variant={`numbersGrid.${variant}.tileBox`}>
        <Text as="h2" text="h2" variant={`numbersGrid.${variant}.tileTitle`}>
          {title}
        </Text>
        <Text as="h3" text="h3" variant={`numbersGrid.${variant}.tileDesc`}>
          {desc}
        </Text>
      </Box>
    </Flex>
  );
};

function NumbersGrid(props: Props) {
  const { title, items, numCols, variant = "default" } = props;

  return (
    <Box variant={`numbersGrid.${variant}.mainBox`}>
      <Text as="h2" text="h2" variant={`numbersGrid.${variant}.title`}>
        {title}
      </Text>
      <Flex variant={`numbersGrid.${variant}.grid`}>
        {items.map(item => (
          <NumbersTile
            title={item.title}
            desc={item.desc}
            width={`${100 / numCols}%`}
            variant={variant}
          />
        ))}
      </Flex>
    </Box>
  );
}

export default NumbersGrid;
